import { render, staticRenderFns } from "./AddLogradourotipoPage.vue?vue&type=template&id=05c1a204&"
import script from "./AddLogradourotipoPage.vue?vue&type=script&lang=js&"
export * from "./AddLogradourotipoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports